var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ew-status",class:'ew-status--' + _vm.info.tone,attrs:{"title":_vm.status && _vm.info.label !== _vm.status ? _vm.status : null}},[_c('span',{staticClass:"ew-status-dot"}),_vm._v(_vm._s(_vm.info.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-118a2c4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/TrackingStatus.vue
// module id = null
// module chunks = 